export default __webpack_public_path__ + "static/media/img_7.75572b4f.jpg";